export const coverConstants = {
    GET_COVER_REQUEST: 'GET_COVER_REQUEST',
    GET_COVER_SUCCESS: 'GET_COVER_SUCCESS',
    GET_COVER_FAILURE: 'GET_COVER_FAILURE',

    UPLOAD_COVER_REQUEST: 'UPLOAD_COVER_REQUEST',
    UPLOAD_COVER_SUCCESS: 'UPLOAD_COVER_SUCCESS',
    UPLOAD_COVER_FAILURE: 'UPLOAD_COVER_FAILURE',

    UPDATE_COVER_REQUEST: 'UPDATE_COVER_REQUEST',
    UPDATE_COVER_SUCCESS: 'UPDATE_COVER_SUCCESS',
    UPDATE_COVER_FAILURE: 'UPDATE_COVER_FAILURE',

    DELETE_COVER_REQUEST: 'DELETE_COVER_REQUEST',
    DELETE_COVER_SUCCESS: 'DELETE_COVER_SUCCESS',
    DELETE_COVER_FAILURE: 'DELETE_COVER_FAILURE',

    RESET_COVER: 'RESET_COVER'
}


// WEBPACK FOOTER //
// ./src/constants/cover.js